<template>
  <div footer>
    <div class="inner-wrap">
      <ul class="sns">
        <li><a href="https://www.facebook.com/newtypeimageworks" target="_blank">Facebook</a></li>
        <li><a href="https://www.instagram.com/newtypeimageworks/" target="_blank">Instagram</a></li>
        <li><a href="https://vimeo.com/newtypeimageworks" target="_blank">Vimeo</a></li>
      </ul>
      <p class="copyright">@2008-2023 Newtype Imageworks.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  lexicon: 'footer',
  data() {
    return {
      sitemapOpen:false,
      langOpen:false,
    };
  },
};
</script>

<style lang="less">
@import "~@/less/proj.less";
[footer] { .bgc(#fff); color: #828282; .pb(24); .mt(80); .fs(16,24);
  &.viewer, &.search { .hide; }

  .dark & { .bgc(#111); color: #b4b4b4; }

  .inner-wrap { .space-m; }
  .sns li { .medium; & + li { .mt(16); }}
  .copyright { .mt(30); .medium; }
}
@media (min-width: @screen-tp-min) {
  [footer] { .pv(30); .mt(80); .fs(18,24);
    .inner-wrap { .flex; justify-content: space-between; flex-direction: row-reverse; }
    .sns li { .ib; .ml(40); & + li { .mt(0); }}
    .copyright { .m; }
  }
}
@media (min-width: @screen-dm-min) {
  [footer] { .mt(100);
    .inner-wrap { .space-d; }
  }
}
@media (min-width: @screen-dx-min) {
  [footer] { .mt(120); .fs(20,28); }
}
</style>
